import GalleryMedia from './GalleryMedia';
import {
  FeaturedImageFrame,
  GalleryThumb,
  GalleryThumbnailsFrame,
  THUMB_SLIDE_CLASS,
  ThumbStripButton
} from './gallery-parts';

/**
 * Simple static version of GalleryView. We can't just reuse GalleryView because
 * Swiper calls Date.now() (which needs Suspense...), so this renders the
 * default image collection with no Swiper and no interactivity.
 */
export default function GallerySkeleton({ collection }) {
  const thumbImages = collection?.image?.slice(0, 5) || [];
  const featuredImage = collection?.image?.[0];

  return (
    <>
      <FeaturedImageFrame>
        {/* Stands in for the main Swiper, which supplies these classes itself. */}
        <div className="md:rounded-11 w-full overflow-hidden">
          {featuredImage?.url && (
            <GalleryMedia image={featuredImage} priority />
          )}
        </div>
      </FeaturedImageFrame>

      <GalleryThumbnailsFrame>
        <ThumbStripButton direction="prev" />
        <div className="flex w-full gap-5">
          {thumbImages.map((image, index) => (
            <div key={`${image.url}-${index}`} className={THUMB_SLIDE_CLASS}>
              <GalleryThumb image={image} />
            </div>
          ))}
        </div>
        <ThumbStripButton direction="next" />
      </GalleryThumbnailsFrame>
    </>
  );
}
